import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthenticationService } from "../services/auth.service";
import { environment } from "../../../environments/environment";


@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Pas de header x-tenant sur les APIs externes (Open-Meteo…) — casse le preflight CORS
    if (request.url.startsWith('http') && !request.url.startsWith(environment.BASE_URL)) {
      return next.handle(request);
    }

    const currentUser = this.authenticationService.currentUser();

    if(currentUser){

      const authReq = request.clone({
        setHeaders: { 'x-tenant': currentUser.tenant || '' }
      });

      return next.handle(authReq);

    }else{
        return next.handle(request);
    }

    
    
    
      
  }
}